import PhoneNumberInput from 'Components/reusable/InputFields/PhoneNumberInput'
import { useContext } from 'react'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Checkbox / switch field.
 */
export const DataEditContextPhoneInput = <T extends AnyObject>({
  field,
  required,
  insetLabel,
  ...rest
}: {
  field: EditableFieldsOfType<T, string>
  insetLabel?: boolean
  required?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t } = useContext<ContextValue<T>>(Context)

  const handleChange = (value: string) => {
    setFields({ [field]: value })
  }

  const dataValue = flatData[field] as unknown as string

  return (
    <PhoneNumberInput
      required={required}
      insetLabel={insetLabel}
      label={t(`${localeBase}.${field}`)}
      onChange={handleChange}
      value={dataValue}
      disabled={disabled[field]}
      {...rest}
    />
  )
}
